import { NewFolderDialog } from "@/action-dialog/dialogs/NewFolderDialog";
import { useRef } from "react";
import { createCallable } from "react-call";

const UNMOUNTING_DELAY_MS = 200;

export type NewFolderCallableProps = {
  workspaceId: string;
  currentPath: string;
};

export const NewFolderCallable = createCallable<
  NewFolderCallableProps,
  boolean
>(({ call, workspaceId, currentPath }) => {
  const succeededRef = useRef(false);

  return (
    <NewFolderDialog
      workspaceId={workspaceId}
      currentPath={currentPath}
      onClose={() => {
        call.end(succeededRef.current);
        succeededRef.current = false;
      }}
      onSuccess={() => {
        succeededRef.current = true;
      }}
    />
  );
}, UNMOUNTING_DELAY_MS);

NewFolderCallable.displayName = "NewFolderCallable";
